module.exports = __webpack_public_path__ + "static/img/far3_active.83718887.png";